import { useLocation } from 'react-router-dom';

import Header from '../../components/Header/Header';
import Routes from '../../routes/Routes';
import { NAV } from '../../routes/routing';

import { $Container } from './Layout.styles';

const ROUTES_WITHOUT_HEADER = [
  NAV.INTERVENTION_SPARE_PARTS,
  NAV.CREATE_QUOTATION,
  NAV.QUOTATION_DETAIL,
];

const Layout = () => {
  const { pathname } = useLocation();
  const hideHeader = ROUTES_WITHOUT_HEADER.some((route) =>
    pathname.includes(route),
  );

  return (
    <$Container>
      {!hideHeader && <Header />}
      <Routes />
    </$Container>
  );
};

export default Layout;
